import { Checkbox, Form, Input, InputNumber, Popconfirm, Select } from 'antd';
import {
  CheckOutlined,
  FileSyncOutlined,
  DeleteRowOutlined,
  StopOutlined,
  ToolOutlined,
  FileProtectOutlined,
  ScheduleOutlined,
  FieldTimeOutlined,
  HistoryOutlined,
  ClusterOutlined,
  TransactionOutlined,
  ThunderboltOutlined,
  SaveOutlined,
  HighlightOutlined,
  PauseCircleOutlined,
  PlayCircleOutlined
} from '@ant-design/icons';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/store';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ButtonActionStatus from '../common/ButtonActionStatus';
import TextArea from 'antd/lib/input/TextArea';
import { AllOptionValue } from 'global/Global';
import UploadImages from './UploadImages';
import { updateIsReqEditOrder } from '@slice/orderManager.slice';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { useAdminConfig } from '../common/Hooks/XuLyDonNo';
import { useBaseOrderStore } from '../layoutContentUWR/BaseOrder/BaseOrderStore';

export enum EStaffsActionMode {
  UNKNOWN = 'UNKNOWN',
  ROOT = 'ROOT',
  ADMIN = 'ADMIN',
  ACCOUNTANT = 'ACCOUNTANT',
  SALE = 'SALE',
  OPERATING = 'OPERATING',
  TECHNICIAN = 'TECHNICIAN',
  CUSTOMERSERVICE = 'CUSTOMERSERVICE'
}

export interface IStaffsActionEvent {
  onClick?: (e?: any) => any;
  // nv kế toán
  declineOrder?: (note?: any) => any;
  approveOrder?: (note?: any) => any;
  approveOrderThuNo?: (note?: any) => any;
  updatePayment?: (moneyPayed?: number, note?: string) => any; // k còn sài nữa

  // nv điều hành
  assignOrder?: (listTech?: any, note?: string) => any;
  restartOrder?: (note?: any) => any;
  changePrior?: (note?: any) => any;
  editComplete?: (note?: any) => any;

  // nv điều hành | nv kth
  pendingOrder?: (note?: any) => any;
  // nv cskh hoặc kd
  reOrder?: (note?: any, role?: string) => any; // truyền thêm role của nv thực hiện để phân biệt
  cancelOrder?: (note?: any, role?: string) => any; // truyền thêm role của nv thực hiện để phân biệt

  // nv cskh
  sendFeedBack?: (note?: any) => any; // cskh gửi xác nhận hoàn tất đơn.

  // nv kthuat
  rejectOrder?: (note?: any) => any;
  getOrder?: (note?: any) => any;
  workingOrder?: (note?: any) => any;
  finishOrder?: (note?: any, maDonHang?: any, type?: any) => any;
  completeOrder?: (note?: any, oldCompany?: string, moreInformation?: string) => any;
  pauseOrder?: (lydo?: string, maDonHang?: any, type?: any) => any;
}

type IOrderStatusActionStaff = {
  maDonHang?: string;
  confirmOrder?: any; // là status đã convert của đơn
  typeOrder?: any;
  branchWorkOrder?: any; // chi nhánh thực hiện đơn
  // gom lại thành modeAction để check nhanh hơn dễ maintenance
  modeAction?: EStaffsActionMode[]; // để mảng vì có thể có nhiều loại nv cùng thao tác vào đơn này
  actionEvents?: IStaffsActionEvent;
  isPrioritized?: boolean;
  setIsPrioritized?: (e: any) => any;
  listStaffAssigned?: any[]; // danh sách nv thực hiện
  rejectInfo?: any[]; // ds nv kthuat từ chối đơn k thực hiện
  payment?: any;
  outTimeUpdate?: boolean; // hết hạn cập nhật sau hoàn tất đơn, trong 1 tuần sau khi kết thúc
  type?: string;
  yeuCauChinhSua?: number;
  typeKeyOrder?: number;
  note?: string;
  valueVat?: any;
};

// phần các btn thao tác...
// khi bảo trì thì mở hàm convertStatusTextToStatusClient trong utilOrder mà coi nhé...thân gửi~!@#$%^&*
export default function OrderStatusActionStaff(props: IOrderStatusActionStaff) {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const { t } = useTranslation();
  const usersTechnician = useSelector((state: RootState) => state.select.usersTechnician);
  const technicianZoneData = useSelector((state: RootState) => state.select.technicianZoneSelectData);
  // const detailBase = useSelector((state: RootState) => state.orderManager.detailBase); // huỷ không dùng
  const detailErrors = useSelector((state: RootState) => state.orderManager.detailErrors);
  const detailUpgrades = useSelector((state: RootState) => state.orderManager.detailUpgrades);
  const detailReplace = useSelector((state: RootState) => state.orderManager.detailReplace);
  const detailPayFees = useSelector((state: RootState) => state.orderManager.detailPayFees);
  const detailThuNos = useSelector((state: RootState) => state.orderManager.detailThuNos);
  const rowSelected = useSelector((state: RootState) => state.orderManager.orderSelect);
  const userAccountTax = useSelector((state: RootState) => state.user.userAccountTax);

  const hasDataBase = useBaseOrderStore(state => state.baseItems.length > 0);

  const isReqEditOrder = useSelector((state: RootState) => state.orderManager.isReqEditOrder);
  const [checkRequest, setCheckRequest] = useState(false);
  const [h, setH] = useState<number>(780);
  const [techZone, setTechZone] = useState<number>(-1);
  const [isRequire, setIsRequire] = useState<boolean>(false);
  const [listStaffWord, setListStaffWord] = useState<any>([]);
  const [noteAction, onChangeNoteAction] = useState<string>('');
  const [oldCompany, onChangeOldCompany] = useState<any>(null);

  const [moreInformation, onChangeMoreInformation] = useState<any>(null);
  // const [moneyPayed, onChangeMoneyPayed] = useState<any>(null);
  // const [acceptStaff, setAcceptStaff] = useState<any[]>([]); // chưa dùng đến list accept

  // vẫn cần check phân quyền user cho các btn này..
  const uLogin = useSelector((state: RootState) => state.user.account);

  const { newValue } = useAdminConfig('UserApproveDebtOrder');
  const checkAuth = uLogin?.username && newValue.includes(uLogin.username);

  const zonesOption = useMemo(() => {
    const techZoneData = technicianZoneData.map(zone => ({ value: zone.id, label: zone.name }));
    techZoneData.unshift(AllOptionValue);
    return techZoneData;
  }, [technicianZoneData]);

  const onChangeTechZone = (e: any) => {
    setTechZone(e);
  };

  const handleCheckOnMap = () => {
    console.log('handleCheckOnMap');
  };

  const handleChangeStaffOrder = (data: any) => {
    console.log('handleChangeStaffOrder', data);
    setListStaffWord(data);
  };

  const assignOrder = () => {
    if (listStaffWord === undefined || (listStaffWord && listStaffWord.length === 0)) {
      setIsRequire(true);
      return 0;
    }

    setIsRequire(false);
    console.log('những nv chỉ định thực hiện đơn', listStaffWord);
    props.actionEvents.assignOrder(listStaffWord, noteAction);
    // cần phải chờ nv kt xn mới chuyển trạng thái tại đây chỉ gửi đơn này cho nv kt đã được chọn
    // tại đây cần xử lý đơn là sửa chữa thì k cần add NV khác
  };

  const renderTechReject = useMemo(() => {
    // console.log('props.rejectInfo', props.rejectInfo);
    return props.rejectInfo?.map((tech, index) => (
      <div key={tech}>
        <span>{tech.staffModify}: </span>
        <span>{tech.note}</span>
      </div>
    ));
  }, [props.rejectInfo]);

  const checkTechGotOrder = useMemo(() => {
    const wait = props.listStaffAssigned.find(
      tech => tech?.staffExecute === uLogin?.username && tech.status === 'Wait'
    );

    const reject = props.listStaffAssigned.find(
      tech => tech?.staffExecute === uLogin?.username && tech.status === 'Reject'
    );

    // setAcceptStaff(props.listStaffAssigned.filter(tech => tech?.status === 'Accept').map(tech => tech.staffExecute));

    // console.log('wait', wait, reject);
    setListStaffWord(props.listStaffAssigned?.map(tech => tech.staffExecute));
    return reject ? 'reject' : wait ? 'wait' : 'accept';
  }, [props.listStaffAssigned, uLogin]);

  // phần lấy dữ liệu tài khoản là kth
  // cần áp lọc các nv theo chi nhánh của đơn đã tạo
  // có thể thêm bộ lọc theo khu vực nếu cần
  const dataTechnician = useMemo(() => {
    // console.log({ usersTechnician });

    return usersTechnician
      .filter(
        techF =>
          !techF.isLocked &&
          props.branchWorkOrder == techF.companyBranchId &&
          (techZone == -1 || techF.technicianZoneId == techZone)
      ) // lọc luôn các kỹ thuật theo chi nhánh thực hiện đơn này

      .map(acc => ({
        value: acc.username,
        label: `${acc.username} - ${acc.displayName}`
        // disable: acceptStaff.includes(acc.username)
      }));
  }, [usersTechnician, props.branchWorkOrder, techZone]);

  const confirmActionDL = (e: any) => {
    props.actionEvents.declineOrder(noteAction);
  };

  const confirmActionCc = (e: any) => {
    console.log('event CC', noteAction, e);
    props.actionEvents.cancelOrder(noteAction, uLogin?.role);
  };

  const confirmActionRJ = (e: any) => {
    props.actionEvents.rejectOrder(noteAction);
  };

  const confirmActionChangePrior = (e: any) => {
    props.actionEvents.changePrior(noteAction);
  };

  useEffect(() => {
    setH(window.innerHeight);
    window.addEventListener('resize', e => {
      setH(window.innerHeight);
    });
  }, []);
  const handleCheckRequest = e => {
    setCheckRequest(e.target.checked);
  };
  // console.log('height', h); //  < 768 là 1366x768; < 900 là 1400x900; < 1100 là 1680 x 1050

  const reqEditButton = useMemo(() => {
    return (
      <>
        <div className="">
          <ButtonActionStatus
            disabled={
              props.typeOrder === 'Trả hàng'
                ? !(
                    (uLogin?.role === 'Accountant' && rowSelected?.status.statusValue === '4') ||
                    (uLogin?.role == 'Technician' && uLogin?.isGuiHang)
                  )
                : !uLogin?.ActionOrder?.updateOrder ||
                  (props.confirmOrder?.statusValue == '4' &&
                    !uLogin?.ActionOrder?.editMoneyAfterComplete &&
                    (uLogin?.role != 'CustomerService' || (uLogin?.role == 'CustomerService' && !props.valueVat)))
            }
            showButton={true}
            onClick={() => {
              dispatch(updateIsReqEditOrder(true));
            }}
            icon={<HighlightOutlined rev={''} style={{ fontSize: '20px', transform: 'translateY(-3px)' }} />}
            text={t('OrganizedSales.CreateOrders.Button.RequireEdit')}
            type="default"
          />
        </div>
      </>
    );
  }, [props.valueVat, props.typeOrder, props.confirmOrder, uLogin, t, dispatch]);

  return (
    <>
      <div className="flex flex-col gap-1 pb-2">
        {/* 
          Kế toán 
          cần quyền declineOrder confirmOrder  viewMap
        */}
        {props.modeAction.includes(EStaffsActionMode.ACCOUNTANT) && uLogin?.role === 'Accountant' && (
          <div className="flex flex-col space-y-2">
            {/* YC đơn khác trạng thái 1 (đơn mới) */}

            {/* {props.confirmOrder.statusValue === '1' && (
              <div className={'flex flex-row gap-2'}>
                <div className={'flex flex-col'}>
                  {uLogin?.ActionOrder?.viewMap && (
                    <label
                      onClick={handleCheckOnMap}
                      className={'text-blue-500 line pb-2 underline cursor-pointer hover:text-blue-600'}
                    >
                      {t('Button.ViewMap')}
                    </label>
                  )}
                </div>
              </div>
            )} */}

            <div className="flex flex-row gap-2">
              {/* <div className="h-fit">
                {uLogin?.ActionOrder?.editPayOrder && props.confirmOrder.statusValue !== '1' && (
                  <Form.Item name="paymented">
                    <InputNumber
                      formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} // hiển thị
                      parser={value => value.replace(/\$\s?|(,*)/g, '')} // giá trị lấy ra
                      onChange={e => onChangeMoneyPayed(e)}
                      style={{ width: '100%' }}
                      placeholder={t('OrganizedSales.OrderManager.ModifyOrder.PlaceHolder.InputMoneyPayed')}
                    />
                  </Form.Item>
                )}
              </div> */}
              <div className="h-fit">
                <Form.Item name="noticeText">
                  <TextArea
                    id="accountant"
                    value={noteAction}
                    onChange={e => onChangeNoteAction(e.target.value)}
                    style={{ width: '100%' }}
                    placeholder={t('Input.pholderActionNote')}
                    showCount
                    rows={2}
                    maxLength={2000}
                  />
                </Form.Item>
              </div>
            </div>

            <div className="flex flex-row gap-2">
              <div className="pr-6 flex space-x-2">
                {!userAccountTax && (
                  <div>
                    {/* cập nhật sau hoàn tất của ktoan */}
                    {props.confirmOrder.statusValue === '4' && (
                      <>
                        {isReqEditOrder ? (
                          <ButtonActionStatus
                            showButton={true}
                            disabled={props.outTimeUpdate}
                            onClick={() => props.actionEvents.editComplete(noteAction)}
                            icon={<SaveOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />}
                            text={t('Button.Order.UpdateInfoComplete')}
                            type="primary"
                          />
                        ) : (
                          reqEditButton
                        )}
                      </>
                    )}
                  </div>
                )}

                {props.typeKeyOrder === 11 ? (
                  <ButtonActionStatus
                    showButton={checkAuth && props.confirmOrder.statusValue === '1'}
                    onClick={() => {
                      props.actionEvents.approveOrderThuNo(noteAction);
                    }}
                    icon={<CheckOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />}
                    text={t('Button.Order.Approve')}
                    type="primary"
                  />
                ) : (
                  !uLogin.onlySeen && (
                    <ButtonActionStatus
                      showButton={uLogin?.ActionOrder?.approveOrder && props.confirmOrder.statusValue === '1'}
                      onClick={() => {
                        props.actionEvents.approveOrder(noteAction);
                      }}
                      icon={<CheckOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />}
                      text={t('Button.Order.Approve')}
                      type="primary"
                    />
                  )
                )}
                {/* Xác nhận đơn khi đơn hợp lệ bằng 1 */}
              </div>

              {props.typeKeyOrder === 11 ? (
                <Popconfirm
                  title={t('OrganizedSales.OrderManager.ModifyOrder.DeclineOrderModal.ConfirmDeclineOrder')}
                  onConfirm={confirmActionDL}
                  onCancel={() => {
                    //
                  }}
                  okText={t('Button.OK')}
                  cancelText={t('Button.Cancel')}
                >
                  {/* Từ chối đơn do ktoan */}
                  <ButtonActionStatus
                    showButton={checkAuth && props.confirmOrder.statusValue === '1'}
                    onClick={() => {
                      //
                    }}
                    icon={<StopOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />}
                    text={t('Button.Order.Decline')}
                    danger
                  />
                </Popconfirm>
              ) : (
                !uLogin.onlySeen && (
                  <Popconfirm
                    title={t('OrganizedSales.OrderManager.ModifyOrder.DeclineOrderModal.ConfirmDeclineOrder')}
                    onConfirm={confirmActionDL}
                    onCancel={() => {
                      //
                    }}
                    okText={t('Button.OK')}
                    cancelText={t('Button.Cancel')}
                  >
                    {/* Từ chối đơn do ktoan */}
                    <ButtonActionStatus
                      showButton={uLogin?.ActionOrder?.declineOrder && props.confirmOrder.statusValue === '1'}
                      onClick={() => {
                        //
                      }}
                      icon={<StopOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />}
                      text={t('Button.Order.Decline')}
                      danger
                    />
                  </Popconfirm>
                )
              )}

              {/* {!uLogin.onlySeen && (
                <Popconfirm
                  title={t('OrganizedSales.OrderManager.ModifyOrder.DeclineOrderModal.ConfirmDeclineOrder')}
                  onConfirm={confirmActionDL}
                  onCancel={() => {
                    //
                  }}
                  okText={t('Button.OK')}
                  cancelText={t('Button.Cancel')}
                >
                  Từ chối đơn do ktoan
                  <ButtonActionStatus
                    showButton={uLogin?.ActionOrder?.declineOrder && props.confirmOrder.statusValue === '1'}
                    onClick={() => {
                      //
                    }}
                    icon={<StopOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />}
                    text={t('Button.Order.Decline')}
                    danger
                  />
                </Popconfirm>
              )} */}
            </div>
          </div>
        )}
        {/* Điều hành thực hiện
          Cần quyền approveOrder, viewMap, selectStaff1
        */}
        {props.modeAction.includes(EStaffsActionMode.OPERATING) && uLogin?.role === 'Operating' && (
          <>
            <div className="flex flex-col space-y-2">
              {/* YC đơn khác trạng thái 1 (đơn mới) | 12 đơn bị kth từ chối thì cho chọn nv thực hiện */}
              {props.confirmOrder.statusValue !== '4' && (
                <div className={'flex flex-col gap-2'}>
                  <div className="flex flex-row items-center gap-4">
                    <div>
                      <label>{t('OrganizedSales.CreateOrders.SubText.SelectZoneTech')}</label>
                      <div>
                        <Select
                          defaultActiveFirstOption={true}
                          onChange={onChangeTechZone}
                          showSearch
                          allowClear={false}
                          optionFilterProp="children"
                          placeholder={t('Select.placeholder')}
                          style={{ width: '100%' }}
                        >
                          {zonesOption.map((item, index) => (
                            <Select.Option key={index} value={item.value}>
                              {t(item.label)}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <Checkbox
                      disabled={uLogin?.ActionOrder?.checkOnFirst ? false : true}
                      style={{ marginBottom: 10, marginTop: 5 }}
                      checked={props.isPrioritized}
                      onChange={e => props.setIsPrioritized(e.target.checked)}
                    >
                      <p style={{ color: '#000', marginBottom: 0 }}>{t('OrganizedSales.CreateOrders.onFirst')}</p>
                    </Checkbox>
                  </div>

                  <div className={'flex flex-col'}>
                    {uLogin?.ActionOrder?.viewMap && (
                      <label
                        onClick={handleCheckOnMap}
                        className={'text-blue-500 line pb-2 underline cursor-pointer hover:text-blue-600'}
                      >
                        {t('Button.ViewMap')}
                      </label>
                    )}
                    {uLogin?.ActionOrder?.selectStaff1 && (
                      <>
                        <label>{t('OrganizedSales.CreateOrders.SubText.SelectStaff')}</label>
                        <div className="flex flex-row gap-2">
                          <Select
                            mode="multiple"
                            style={{
                              maxHeight: '260px',
                              overflowX: 'hidden',
                              maxWidth: '90%',
                              minWidth: '60%'
                            }}
                            showSearch
                            allowClear
                            placeholder={t('Select.placeholderStaff')}
                            optionFilterProp="children"
                            onChange={handleChangeStaffOrder}
                            value={listStaffWord}
                            defaultValue={props.listStaffAssigned?.map(tech => tech.staffExecute) || []}
                          >
                            {dataTechnician.map((item, index) => (
                              <Select.Option
                                // disabled={item.disable}
                                label={item.label}
                                value={item.value}
                                key={index}
                              >
                                {item.label}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                        <label
                          className={classNames(
                            isRequire && listStaffWord.length === 0 ? 'block' : 'hidden',
                            'text-red-500'
                          )}
                        >
                          {t('Input.FieldError.RequireText')}
                        </label>
                      </>
                    )}
                  </div>
                </div>
              )}

              <Form.Item name="noticeText">
                <TextArea
                  id="operating"
                  value={noteAction}
                  onChange={e => onChangeNoteAction(e.target.value)}
                  style={{ width: '100%' }}
                  placeholder={t('Input.pholderActionNote')}
                  defaultValue={noteAction}
                  showCount
                  rows={2}
                  maxLength={2000}
                />
              </Form.Item>

              {props.confirmOrder.statusValue === '4' ? (
                <>
                  {/* Sau khi đơn hoàn tất thì mở ra để đh có thể cập nhật lại thông tin của chi tiết mà kth làm */}

                  {uLogin?.isHeadOfDepartment && (
                    <UploadImages
                      rowSelected={rowSelected}
                      data={props}
                      status={props.confirmOrder.vnText}
                      typeKeyOrder={props.typeKeyOrder}
                    />
                  )}
                  {reqEditButton ? (
                    <ButtonActionStatus
                      showButton={uLogin?.ActionOrder?.assignOrder}
                      disabled={props.outTimeUpdate}
                      onClick={() => props.actionEvents.editComplete(noteAction)}
                      icon={<SaveOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />}
                      text={t('Button.Order.EditComplete')}
                      type="primary"
                    />
                  ) : (
                    reqEditButton
                  )}
                </>
              ) : (
                <>
                  <div className="flex flex-row">
                    <div className="flex flex-row gap-2 pr-4">
                      {/* đơn bị hoãn thì đh là người quyết định cho đơn này hồi lại.. */}
                      {props.confirmOrder.statusValue === '3' && (
                        <ButtonActionStatus
                          showButton={uLogin?.ActionOrder?.restartProcess}
                          onClick={() => props.actionEvents.restartOrder(noteAction)}
                          icon={
                            <HistoryOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />
                          }
                          text={t('Button.Order.ReStart')}
                          type="primary"
                        />
                      )}
                      {/* hoặc đang bằng xx chờ đh chọn kt xong điều | hoặc đh bấm để điều đơn trừ đơn hẹn lại sau thì k có điều đc đâu */}
                      {props.confirmOrder.statusValue !== '3' && props.confirmOrder.statusValue !== '5' && (
                        <ButtonActionStatus
                          showButton={uLogin?.ActionOrder?.assignOrder}
                          onClick={() => assignOrder()}
                          icon={
                            <ClusterOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />
                          }
                          text={t('Button.Order.Assign')}
                          type="primary"
                        />
                      )}
                    </div>
                    {/* h > 1366 ? 'flex-row-reverse' : 'flex-col' */}
                    <div className={classNames('flex-col flex gap-2')}>
                      <div className="flex flex-row gap-2">
                        {/* hoãn đơn nếu đơn này đang ở trạng thái hẹn lại | chờ điều | điều xong | đang làm mà hoãn ngang */}
                        {(props.confirmOrder.statusValue === '12' ||
                          props.confirmOrder.statusValue === '7' ||
                          props.confirmOrder.statusValue === '2' ||
                          props.confirmOrder.statusValue === '3') && (
                          <ButtonActionStatus
                            showButton={uLogin?.ActionOrder?.postpone}
                            onClick={() => props.actionEvents.pendingOrder(noteAction)}
                            icon={
                              <FieldTimeOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />
                            }
                            text={t('Button.Order.Postpone')}
                            danger
                          />
                        )}
                        {props.confirmOrder.statusValue != '5' && (
                          <Popconfirm
                            title={t('OrganizedSales.OrderManager.ModifyOrder.CancelOrderModal.ConfirmCancelOrder')}
                            onConfirm={confirmActionCc}
                            onCancel={() => {
                              //
                            }}
                            okText={t('Button.OK')}
                            cancelText={t('Button.Cancel')}
                          >
                            <ButtonActionStatus
                              showButton={uLogin?.ActionOrder?.cancelOrder}
                              onClick={() => {
                                //
                              }}
                              icon={
                                <DeleteRowOutlined
                                  rev={''}
                                  style={{ fontSize: '21px', transform: 'translateY(-3px)' }}
                                />
                              }
                              text={t('Button.Order.Cancel')}
                              danger
                            />
                          </Popconfirm>
                        )}
                      </div>
                      <div className="flex justify-between">
                        <div></div>
                        {props.confirmOrder.statusValue !== '5' && (
                          <Popconfirm
                            title={t('OrganizedSales.OrderManager.ModifyOrder.ConfirmActionChangePrior')}
                            onConfirm={confirmActionChangePrior}
                            onCancel={() => {
                              //
                            }}
                            okText={t('Button.OK')}
                            cancelText={t('Button.Cancel')}
                          >
                            <ButtonActionStatus
                              showButton={uLogin?.ActionOrder?.checkOnFirst}
                              onClick={() => {
                                //
                              }}
                              icon={
                                <ThunderboltOutlined
                                  rev={''}
                                  style={{ fontSize: '21px', transform: 'translateY(-3px)' }}
                                />
                              }
                              text={t('Button.Order.ChangePrior')}
                              danger
                            />
                          </Popconfirm>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}

              {props.rejectInfo?.length !== 0 && props.confirmOrder.statusValue === '7' && (
                <>
                  <div className="text-sx text-gray-500">
                    {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ResionReject')}:{' '}
                    <span className="text-gray-600 font-semibold">{renderTechReject}</span>
                  </div>
                </>
              )}
            </div>
          </>
        )}
        {/* TK là KD hoặc CSKH có thể huỷ đơn hoặc đặt lại đơn đã bị từ chối cho kto
          Cần quyền cancelOrder reOrder
        */}
        {(props.modeAction.includes(EStaffsActionMode.SALE) ||
          props.modeAction.includes(EStaffsActionMode.CUSTOMERSERVICE)) &&
          (uLogin?.role === 'Sale' ||
            uLogin?.role === 'CustomerService' ||
            uLogin?.role == 'Root' ||
            uLogin?.role == 'Admin') && (
            <div className="flex flex-col space-y-4">
              <div className="flex flex-row gap-2">
                {/* đơn chỉ được huỷ khi bị kto từ chối hoặc mới tạo hoặc đang chờ điều phối */}

                <div className="block w-full space-y-2 gap-2">
                  {((uLogin?.ActionOrder?.sendFeedback && props.confirmOrder.statusValue === '4') ||
                    (props.confirmOrder.statusValue === '4' && uLogin.ActionOrder.editMoneyAfterComplete) ||
                    props.confirmOrder.statusValue !== '4') && (
                    <Form.Item name="noticeText">
                      <TextArea
                        id="saleAndCus"
                        value={noteAction}
                        onChange={e => onChangeNoteAction(e.target.value)}
                        style={{ width: '100%' }}
                        placeholder={t('Input.pholderActionNote')}
                        showCount
                        rows={2}
                        maxLength={2000}
                      />
                    </Form.Item>
                  )}

                  {props.confirmOrder.statusValue !== '4' &&
                    props.confirmOrder.statusValue !== '5' &&
                    props.type !== 'baocaodonhang' && (
                      <Popconfirm
                        title={t('OrganizedSales.OrderManager.ModifyOrder.CancelOrderModal.ConfirmCancelOrder')}
                        onConfirm={confirmActionCc}
                        onCancel={() => {
                          //
                        }}
                        okText={t('Button.OK')}
                        cancelText={t('Button.Cancel')}
                      >
                        <ButtonActionStatus
                          showButton={uLogin?.ActionOrder?.cancelOrder}
                          onClick={() => {
                            //
                          }}
                          icon={
                            <DeleteRowOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />
                          }
                          text={t('Button.Order.Cancel')}
                          danger
                        />
                      </Popconfirm>
                    )}

                  <div className="flex space-x-2">
                    <div>
                      {props.confirmOrder.statusValue === '4' && (
                        <>
                          {isReqEditOrder ? (
                            <ButtonActionStatus
                              showButton={uLogin?.isHeadOfDepartment || uLogin?.role === 'CustomerService'} // là cskh là cho sửa  này...
                              disabled={props.outTimeUpdate}
                              onClick={() => props.actionEvents.editComplete(noteAction)}
                              icon={
                                <SaveOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />
                              }
                              text={t('Button.Order.UpdateInfoComplete')}
                              type="primary"
                            />
                          ) : (
                            reqEditButton
                          )}
                        </>
                      )}
                    </div>

                    <div>
                      {props.confirmOrder.statusValue === '4' && (
                        <ButtonActionStatus
                          showButton={uLogin?.ActionOrder?.sendFeedback}
                          onClick={() => props.actionEvents.sendFeedBack(noteAction)}
                          icon={
                            <FieldTimeOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />
                          }
                          type="default"
                          text={t('Button.Order.SendFeedback')}
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* lưu ý chỉ đơn hàng đã bị từ chối do ktoan thì mới có bước reOrder lại đơn */}
                {/* hiện tại chưa dùng tạo lại đơn */}
                {/* <ButtonActionStatus
                  showButton={props.confirmOrder.statusValue === '6' && uLogin?.ActionOrder?.reOrder}
                  onClick={() => props.actionEvents.reOrder(uLogin?.role)}
                  icon={<FileSyncOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />}
                  text={t('Button.Order.ReOrder')}
                  type="primary"
                /> */}

                {/* {(props.confirmOrder.statusValue === '12' ||
                  props.confirmOrder.statusValue === '7' ||
                  props.confirmOrder.statusValue === '2') && (
                  <ButtonActionStatus
                    showButton={uLogin?.ActionOrder?.postpone}
                    onClick={() => props.actionEvents.pendingOrder(noteAction)}
                    icon={<FieldTimeOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />}
                    text={t('Button.Order.Postpone')}
                    danger
                  />
                )} */}
              </div>
              {props.confirmOrder.statusValue === '4' && uLogin?.ActionOrder?.cancelOrderAfterComplete && (
                <Popconfirm
                  title={t('OrganizedSales.OrderManager.ModifyOrder.CancelOrderModal.ConfirmCancelOrder')}
                  onConfirm={confirmActionCc}
                  onCancel={() => {
                    //
                  }}
                  okText={t('Button.OK')}
                  cancelText={t('Button.Cancel')}
                >
                  <ButtonActionStatus
                    showButton={uLogin?.ActionOrder?.cancelOrder}
                    disabled={props.outTimeUpdate}
                    onClick={() => {
                      //
                    }}
                    icon={<DeleteRowOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />}
                    text={t('Button.Order.Cancel')}
                    danger
                  />
                </Popconfirm>
              )}
            </div>
          )}

        {/* kỹ thuật */}

        {props.modeAction.includes(EStaffsActionMode.TECHNICIAN) && uLogin?.role === 'Technician' && (
          <>
            {/* chỗ này cần check ai đã tiếp nhận đơn vì đơn luôn ở Assigned để biết mà bỏ ra! */}
            {(props.confirmOrder.statusValue === '7' || props.confirmOrder.statusValue === '2') &&
              checkTechGotOrder == 'wait' && (
                <>
                  <Form.Item name="noticeText">
                    <TextArea
                      id="techAwait"
                      value={noteAction}
                      onChange={e => onChangeNoteAction(e.target.value)}
                      style={{ width: '100%' }}
                      placeholder={t('Input.pholderActionNote')}
                      showCount
                      rows={2}
                      maxLength={2000}
                    />
                  </Form.Item>
                  <div className="flex flex-row gap-2">
                    <div className="pr-6">
                      {/* tiếp nhận đơn, đơn có nhiều người thì chờ tiếp nhận.. */}
                      <ButtonActionStatus
                        showButton={uLogin?.ActionOrder?.workingOrder}
                        onClick={() => props.actionEvents.getOrder(noteAction)}
                        icon={<CheckOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />}
                        text={t('Button.Order.GetOrder')}
                        type="primary"
                      />
                    </div>

                    {/* không tiếp nhận do nguyên nhân gì gi */}
                    <Popconfirm
                      title={t('OrganizedSales.OrderManager.ModifyOrder.RejectOrderModal.ConfirmRejectOrder')}
                      onConfirm={confirmActionRJ}
                      onCancel={() => {
                        //
                      }}
                      okText={t('Button.OK')}
                      cancelText={t('Button.Cancel')}
                    >
                      <ButtonActionStatus
                        showButton={uLogin?.ActionOrder?.workingOrder}
                        onClick={() => {
                          //
                        }}
                        icon={<StopOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />}
                        text={t('Button.Order.RejectOrder')}
                        danger
                      />
                    </Popconfirm>
                  </div>
                </>
              )}
            {checkTechGotOrder == 'reject' && (
              <>
                <span className="font-semibold p-2 text-red-600">
                  {t('OrganizedSales.OrderManager.ModifyOrder.DeclineOrderModal.Title')}
                </span>
              </>
            )}
            {checkTechGotOrder == 'accept' && (
              <>
                {props.typeOrder == 'Thu đổi' && (
                  <div className="flex flex-row gap-2">
                    <Input
                      id="oldCom"
                      value={oldCompany}
                      onChange={e => onChangeOldCompany(e.target.value)}
                      style={{ width: '100%' }}
                      placeholder={t('OrganizedSales.OrderManager.ModifyOrder.PlaceHolder.InputOldCompany')}
                    />
                    <Input
                      id="moreInfo"
                      value={moreInformation}
                      onChange={e => onChangeMoreInformation(e.target.value)}
                      style={{ width: '100%' }}
                      placeholder={t('OrganizedSales.OrderManager.ModifyOrder.PlaceHolder.InputMoreInfo')}
                    />
                  </div>
                )}

                <Form.Item name="noticeText">
                  <TextArea
                    id="techWoking"
                    value={noteAction}
                    onChange={e => onChangeNoteAction(e.target.value)}
                    style={{ width: '100%' }}
                    placeholder={t('Input.pholderActionNote')}
                    showCount
                    rows={2}
                    maxLength={2000}
                  />
                </Form.Item>
                <UploadImages
                  rowSelected={rowSelected}
                  data={props}
                  status={props.confirmOrder.vnText}
                  typeKeyOrder={props.typeKeyOrder}
                />
                {props.confirmOrder.statusValue === '2' && uLogin?.ActionOrder?.finishOrder ? (
                  <>
                    <Checkbox onChange={handleCheckRequest} checked={checkRequest}>
                      {t('Button.Order.RequestOrder')}
                    </Checkbox>
                  </>
                ) : (
                  ''
                )}
                {/* KHU VỰC MỚI: Checkbox và nút Pause/Resume */}
                {/* <div className="flex flex-row items-center justify-between bg-orange-50 p-3 rounded-lg border border-orange-100 my-2">
               
                  <div className="flex items-center">
                    {props.confirmOrder.statusValue === '2' && uLogin?.ActionOrder?.finishOrder && (
                      <Checkbox
                        onChange={handleCheckRequest}
                        checked={checkRequest}
                        className="text-gray-700 font-medium"
                      >
                        {t('Button.Order.RequestOrder')}
                      </Checkbox>
                    )}
                  </div>

                
                  <div>
                    {props.confirmOrder.statusValue === '2' && (
                      <ButtonActionStatus
                        showButton={true}
                        onClick={() => {
                          if (!noteAction) return alert(t('Message.PleaseInputPauseReason'));
                          // props.actionEvents.requestPauseOrder(noteAction);
                        }}
                        icon={<PauseCircleOutlined rev={''} style={{ fontSize: '18px' }} />}
                        text={t('Button.Order.Pause')}
                        // Đổi sang style mềm mại hơn
                        style={{
                          backgroundColor: '#faad14',
                          color: 'white',
                          border: 'none',
                          borderRadius: '6px',
                          boxShadow: '0 2px 0 rgba(0,0,0,0.045)',
                          minWidth: '110px'
                        }}
                      />
                    )}

                    {props.confirmOrder.statusValue === '15' && (
                      <ButtonActionStatus
                        showButton={true}
                        icon={<PlayCircleOutlined rev={''} style={{ fontSize: '18px' }} />}
                        text={t('Button.Order.Resume')}
                        type="primary"
                        style={{ borderRadius: '6px', minWidth: '110px' }}
                      />
                    )}
                  </div>
                </div> */}

                <div className={classNames(h > 700 ? 'flex-row' : 'flex-col', 'flex gap-2')}>
                  <div className="flex flex-row gap-2 pr-6">
                    {/* Hoàn thành công việc thì bấm vào để finish đơn có thể có nhiều người hoàn thành */}
                    <ButtonActionStatus
                      showButton={props.confirmOrder.statusValue === '2' && uLogin?.ActionOrder?.finishOrder}
                      onClick={() => {
                        checkRequest
                          ? props.actionEvents.finishOrder(noteAction, props.maDonHang, 'checkRequest')
                          : props.actionEvents.finishOrder(noteAction);
                        setCheckRequest(false);
                      }}
                      disabled={
                        !hasDataBase &&
                        detailErrors.length == 0 &&
                        detailUpgrades.length == 0 &&
                        detailReplace.length == 0 &&
                        detailPayFees.length == 0 &&
                        detailThuNos.length == 0
                      } // đơn nào lắp mới gửi đỏi thì mới check này
                      icon={<ScheduleOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />}
                      text={t('Button.Order.DoneWork')}
                      type="default"
                    />
                    {/* Người Kthuat đầu bấm thực hiện thì có quyền bấm complete để đơn này hoàn tất */}
                    <ButtonActionStatus
                      showButton={props.confirmOrder.statusValue === '2' && uLogin?.ActionOrder?.completeOrder}
                      onClick={() => props.actionEvents.completeOrder(noteAction, oldCompany, moreInformation)}
                      icon={
                        <FileProtectOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />
                      }
                      disabled={props.yeuCauChinhSua == 1}
                      text={t('Button.Order.DoneOrder')}
                      type="primary"
                    />
                    {/* bắt tay vào làm thì nhấn để Processing tại đây có liên quan đến đơn hẹn thì có thể nhấn bắt đầu thực hiện hay k*/}
                    <ButtonActionStatus
                      showButton={
                        props.confirmOrder.statusValue === '7' && uLogin?.ActionOrder?.workingOrder ? true : false
                      }
                      onClick={() => props.actionEvents.workingOrder(noteAction)}
                      icon={<ToolOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />}
                      text={t('Button.Order.StartWork')}
                      ghost
                      type="primary"
                    />
                    {(props.confirmOrder.statusValue === '12' ||
                      props.confirmOrder.statusValue === '7' ||
                      props.confirmOrder.statusValue === '2' ||
                      props.confirmOrder.statusValue === '3') && (
                      <ButtonActionStatus
                        showButton={uLogin?.ActionOrder?.postpone}
                        onClick={() => props.actionEvents.pendingOrder(noteAction)}
                        icon={
                          <FieldTimeOutlined rev={''} style={{ fontSize: '21px', transform: 'translateY(-3px)' }} />
                        }
                        text={t('Button.Order.Postpone')}
                        danger
                      />
                    )}
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
}
